export const MuiSvgIcon = {
  root: {
    fill: 'none',
    fontSize: 24,
  },
  fontSizeLarge: {
    fontSize: 48,
  },
};
